import React, { useState } from "react";
import { ListarTipoPesoAtendimentoAtivosController } from "../../../../../Controllers/Geral/GestaoDeCadastros/TipoPesoAtendimento/TipoPesoAtedimentoControllers";
import { ITipoPesoAtendimento } from "../../../../../Interfaces/Geral/GestaoDeCadastro/TipoPesoAtendimento/TipoPesoAtendimentoInterfaces";
import LazySelect from "../../../Forms/LazySelect";

interface ISeletorPesoAtendimentoProps
    extends Omit<
        Parameters<typeof LazySelect>[0],
        "controller" | "getDS" | "getKeyValue"
    > {}

function SeletorPesoAtendimento(
    props: ISeletorPesoAtendimentoProps,
    ref: React.ForwardedRef<HTMLSelectElement>
) {
    const [pesoAtendimento, setPesoAtendimento] =
        useState<ITipoPesoAtendimento>();
    const [lstTipoPesoAtendimento, setLstTipoPesoAtendimento] =
        useState<Array<ITipoPesoAtendimento>>();

    return (
        <div className="input-group mb-5">
            <div className="input-group-prepend">
                <span className="input-group-text">
                    <i
                        className={
                            pesoAtendimento?.DS_ICON_PESO_ATENDIMENTO ??
                            "fas fa-balance-scale"
                        }
                        style={{
                            color:
                                pesoAtendimento?.HX_COR_PESO_ATENDIMENTO ??
                                "#000000",
                        }}
                    ></i>
                </span>
            </div>
            <LazySelect
                {...props}
                placeholder="Peso do Atendimento"
                controller={ListarTipoPesoAtendimentoAtivosController}
                className={`form-control placeholder-dark-50`}
                ref={ref}
                getDS={(p) => p.DS_TIPO_PESO_ATENDIMENTO}
                getKeyValue={(p) => p.ID_TIPO_PESO_ATENDIMENTO}
                onOptionsLoad={setLstTipoPesoAtendimento}
                onChange={(e) => {
                    const selected = e.target.value;
                    const tipoPeso = lstTipoPesoAtendimento?.find(
                        (p) => p.ID_TIPO_PESO_ATENDIMENTO === Number(selected)
                    );
                    setPesoAtendimento(tipoPeso);
                }}
            >
                <option value={undefined}>Peso do Atendimento</option>
            </LazySelect>
        </div>
    );
}

export default React.forwardRef(SeletorPesoAtendimento);
